import request from '@/utils/request'

export function searchReport(branchId, date) {
  return request({
    url: 'store/getDailyReport/' + branchId + '/' + date,
    method: 'get',
  });
}
